'use client';

import { useState, useEffect } from 'react';
import { onNetworkStatusChange } from '@/lib/errorHandling';

/**
 * Hook for monitoring network status
 */
export function useNetworkStatus() {
  // Always start with true to ensure server/client hydration match
  // The real network status will be set in useEffect after hydration
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    // Set the actual network status after hydration
    if (typeof navigator !== 'undefined') {
      setIsOnline(navigator.onLine);
    }
    
    // Set up listeners for network changes
    const unsubscribe = onNetworkStatusChange(
      () => setIsOnline(true),
      () => setIsOnline(false)
    );
    
    return unsubscribe;
  }, []);

  return {
    isOnline,
    isOffline: !isOnline,
  };
}